//LOADER ACTIONS
export const ADD_LOADER = 'ADD_LOADER'
export const REMOVE_LOADER = 'REMOVE_LOADER'
export const UPDATE_LOADER = 'UPDATE_LOADER'
export const REMOVE_ALL_LOADERS = 'REMOVE_ALL_LOADERS'
export const addLoader = (loaderId) => ({
  type: ADD_LOADER,
  data: loaderId,
})

export const removeLoader = (loaderId) => ({
  type: REMOVE_LOADER,
  data: loaderId,
})

export const updateLoader = (loaderId) => ({
  type: UPDATE_LOADER,
  loaderId,
})

export const removeAllLoaders = () => ({
  type: REMOVE_ALL_LOADERS,
})
